import React from 'react';
import { makeStyles } from '@material-ui/core';

import Container from '../Container';

const TitleBar = (props) => {
    const classes = useStyles();
    return (
        <div className={`${classes.titleBar} ${props.className} titleBar`} >
            <Container>
                <div className="displayArea" >
                    <div className="title">
                        <h3 className="main-title">
                            {props.mainTitle}
                        </h3>
                        <h5 className="sub-title">
                            {props.subTitle}
                        </h5>
                    </div>
                    {props.children}
                </div>
            </Container>
        </div>
    );
}

export default TitleBar;

const useStyles = makeStyles((theme) => ({
    titleBar: {
        display: 'flex',
        boxSizing: 'border-box',
        width: "100%",
        flexDirection: 'column',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        '&:before': {
            display: 'block',
            content: '""',
            width: '100%',
            height: '70px'
        },
        '& .displayArea': {
            position: 'relative',
            height: '70px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .main-title': {
                margin: 0
            },
            '& .sub-title': {
                display: 'none'
            }
        },
        '@media (min-width:768px)': {
            '& .displayArea': {
                paddingTop: '0.5rem',
                '& .title': {
                    display: 'flex',
                    alignItems: "baseline",
                    '& .main-title': {
                        marginRight: '10px'
                    },
                    '& .sub-title': {
                        display: 'inline'
                    }
                }
            }
        }
    }
}));
